import { Expose } from "class-transformer";

export class AddPurchaseOrdersToDeliveryNoteDto {
  @Expose()
  purchaseOrderIds: string[];
}
